import React from 'react';
import SelectItem from './Select';

const Item = () => {
  return <SelectItem />;
};
export default Item;
